import { render, staticRenderFns } from "./principleAdminForm.vue?vue&type=template&id=c369e310&scoped=true&"
import script from "./principleAdminForm.vue?vue&type=script&lang=js&"
export * from "./principleAdminForm.vue?vue&type=script&lang=js&"
import style0 from "./principleAdminForm.vue?vue&type=style&index=0&id=c369e310&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c369e310",
  null
  
)

export default component.exports